import { FORM30_TABLES } from "./form30Tables";

/**
 * Маппинг между номерами колонок (из JSON) и ключами колонок (в приложении)
 * Формат: { tableId: { columnNumber: columnKey } }
 */
export const COLUMN_NUMBER_TO_KEY_MAP: Record<string, Record<string, string>> = {};

/**
 * Обратный маппинг: ключ колонки -> номер колонки
 * Формат: { tableId: { columnKey: columnNumber } }
 */
export const COLUMN_KEY_TO_NUMBER_MAP: Record<string, Record<string, string>> = {};

// Автоматически генерируем маппинг на основе конфигурации таблиц
FORM30_TABLES.forEach(table => {
    COLUMN_NUMBER_TO_KEY_MAP[table.id] = {};
    COLUMN_KEY_TO_NUMBER_MAP[table.id] = {};
    
    let columnNumber = 1;
    table.columns.forEach(column => {
        const numStr = columnNumber.toString();
        
        // Пропускаем текстовые колонки в маппинге (они не сохраняются)
        if (column.type === 'number') {
            COLUMN_NUMBER_TO_KEY_MAP[table.id][numStr] = column.key;
            COLUMN_KEY_TO_NUMBER_MAP[table.id][column.key] = numStr;
        }
        
        columnNumber++;
    });
});

/**
 * Маппинг между rowId в приложении и rowId в JSON
 * JSON использует упрощенные ID (например "4_1", "all", "0-4")
 * Приложение использует более описательные ID (например "row_4_1", "row_total", "row_0_4")
 */
export const ROW_ID_TO_JSON_MAP: Record<string, Record<string, string>> = {
    'child_count': {
        'row_1_1': '1_1',
        'row_1_1_1': '1_1_1',
        'row_1_1_2': '1_1_2',
        'row_1_1_3': '1_1_3',
        'row_1_1_4': '1_1_4',
        'row_1_1_5': '1_1_5',
        'row_1_1_6': '1_1_6',
        'row_2': '2',
        'row_2_1': '2_1',
        'row_2_1_1': '2_1_1',
        'row_2_1_2': '2_1_2',
        'row_2_1_3': '2_1_3',
        'row_2_1_4': '2_1_4',
        'row_2_1_5': '2_1_5',
        'row_2_1_6': '2_1_6',
    },
    'structure_of_diseases_1000': {
        'row_1': '1',
        'row_1_1': '1_1',
        'row_1_2': '1_2',
        'row_2': '2',
        'row_3': '3',
        'row_3_1': '3_1',
        'row_4': '4',
        'row_4_1': '4_1',
        'row_4_2': '4_2',
        'row_4_3': '4_3',
        'row_4_3_1': '04_03_2001',
        'row_4_4': '4_4',
        'row_4_5': '4_5',
        'row_5': '5',
        'row_5_1': '5_1',
        'row_6': '6',
        'row_6_1': '6_1',
        'row_7': '7',
        'row_7_1': '7_1',
        'row_7_2': '7_2',
        'row_8': '8',
        'row_9': '9',
        'row_9_1': '9_1',
        'row_10': '10',
        'row_10_1': '10_1',
        'row_11': '11',
        'row_11_1': '11_1',
        'row_12': '12',
        'row_13': '13',
        'row_13_1': '13_1',
        'row_13_2': '13_2',
        'row_13_3': '13_3',
        'row_14': '14',
        'row_14_1': '14_1',
        'row_14_2': '14_2',
        'row_14_3': '14_3',
        'row_14_4': '14_4',
        'row_14_5': '14_5',
        'row_15': '15',
        'row_16': '16',
        'row_16_1': '16_1',
        'row_16_2': '16_2',
        'row_16_3': '16_3',
        'row_16_4': '16_4',
        'row_16_5': '16_5',
        'row_16_6': '16_6',
        'row_16_7': '16_7',
        'row_16_8': '16_8',
        'row_16_9': '16_9',
        'row_17': '17',
        'row_18': '18',
    },
    'additional_consultations_2000': {
        'row_total': 'all',
        'row_0_4': '0-4',
        'row_0_14': '0-14',
        'row_5_9': '5-9',
        'row_10_14': '10-14',
        'row_15_17': '15-17',
    },
    'rehabilitation_3000': {
        'row_total': 'all',
        'row_0_4': '0-4',
        'row_0_14': '0-14',
        'row_5_9': '5-9',
        'row_10_14': '10-14',
        'row_15_17': '15-17',
    },
    'physical_development_4000': {
        'row_total': 'all',
        'row_0_4': '0-4',
        'row_0_14': '0-14',
        'row_5_9': '5-9',
        'row_10_14': '10-14',
        'row_15_17': '15-17',
    },
    'physical_development_groups_5000': {
        'row_total': 'all',
        'row_0_4': '0-4',
        'row_0_4_boys': '0-4_boys',
        'row_0_14': '0-14',
        'row_0_14_boys': '0-14_boys',
        'row_5_9': '5-9',
        'row_5_9_boys': '5-9_boys',
        'row_10_14': '10-14',
        'row_10_14_boys': '10-14_boys',
        'row_15_17': '15-17',
        'row_15_17_boys': '15-17_boys',
    },
    'health_groups_6000': {
        'row_total': 'all',
        'row_0_4': '0-4',
        'row_0_4_boys': '0-4_boys',
        'row_0_14': '0-14',
        'row_0_14_boys': '0-14_boys',
        'row_5_9': '5-9',
        'row_5_9_boys': '5-9_boys',
        'row_10_14': '10-14',
        'row_10_14_boys': '10-14_boys',
        'row_15_17': '15-17',
        'row_15_17_boys': '15-17_boys',
    },
};

/**
 * Обратный маппинг: JSON rowId -> приложение rowId
 */
export const JSON_TO_ROW_ID_MAP: Record<string, Record<string, string>> = {};

// Генерируем обратный маппинг
Object.keys(ROW_ID_TO_JSON_MAP).forEach(tableId => {
    JSON_TO_ROW_ID_MAP[tableId] = {};
    Object.entries(ROW_ID_TO_JSON_MAP[tableId]).forEach(([appRowId, jsonRowId]) => {
        JSON_TO_ROW_ID_MAP[tableId][jsonRowId] = appRowId;
    });
});

/**
 * Конвертирует данные из формата JSON в формат приложения
 */
export function convertJsonToAppFormat(jsonData: any): Record<string, Record<string, Record<string, number | null>>> {
    const appData: Record<string, Record<string, Record<string, number | null>>> = {};
    
    Object.keys(jsonData).forEach(tableId => {
        if (!COLUMN_NUMBER_TO_KEY_MAP[tableId] || !JSON_TO_ROW_ID_MAP[tableId]) {
            console.warn(`Unknown table: ${tableId}`);
            return;
        }
        
        appData[tableId] = {};
        const tableData = jsonData[tableId];
        
        // Специальная обработка для child_count (вложенная структура)
        if (tableId === 'child_count') {
            // В JSON: { "1": { "1_1": 200, "1_1_1": 200 }, "2": { "2_1": 200 } }
            Object.keys(tableData).forEach(groupKey => {
                const groupData = tableData[groupKey];
                
                Object.keys(groupData).forEach(jsonRowId => {
                    const appRowId = JSON_TO_ROW_ID_MAP[tableId][jsonRowId];
                    if (!appRowId) {
                        console.warn(`Unknown row ID in table ${tableId}: ${jsonRowId}`);
                        return;
                    }
                    
                    appData[tableId][appRowId] = {};
                    const value = groupData[jsonRowId];
                    
                    // В child_count только одна числовая колонка - 'people'
                    const columnKey = COLUMN_NUMBER_TO_KEY_MAP[tableId]['3']; // колонка "Человек"
                    if (columnKey) {
                        appData[tableId][appRowId][columnKey] = value;
                    }
                });
            });
        } else {
            // Обычная обработка для остальных таблиц
            Object.keys(tableData).forEach(jsonRowId => {
                const appRowId = JSON_TO_ROW_ID_MAP[tableId][jsonRowId];
                if (!appRowId) {
                    console.warn(`Unknown row ID in table ${tableId}: ${jsonRowId}`);
                    return;
                }
                
                appData[tableId][appRowId] = {};
                const rowData = tableData[jsonRowId];
                
                Object.keys(rowData).forEach(columnNumber => {
                    const columnKey = COLUMN_NUMBER_TO_KEY_MAP[tableId][columnNumber];
                    if (!columnKey) {
                        console.warn(`Unknown column number in table ${tableId}: ${columnNumber}`);
                        return;
                    }
                    
                    appData[tableId][appRowId][columnKey] = rowData[columnNumber];
                });
            });
        }
    });
    
    return appData;
}

/**
 * Конвертирует данные из формата приложения в формат JSON
 */
export function convertAppToJsonFormat(appData: Record<string, Record<string, Record<string, number | null>>>): any {
    const jsonData: any = {};
    
    Object.keys(appData).forEach(tableId => {
        if (!COLUMN_KEY_TO_NUMBER_MAP[tableId] || !ROW_ID_TO_JSON_MAP[tableId]) {
            console.warn(`Unknown table: ${tableId}`);
            return;
        }
        
        jsonData[tableId] = {};
        const tableData = appData[tableId];
        
        Object.keys(tableData).forEach(appRowId => {
            const jsonRowId = ROW_ID_TO_JSON_MAP[tableId][appRowId];
            if (!jsonRowId) {
                console.warn(`Unknown row ID in table ${tableId}: ${appRowId}`);
                return;
            }
            
            jsonData[tableId][jsonRowId] = {};
            const rowData = tableData[appRowId];
            
            Object.keys(rowData).forEach(columnKey => {
                const columnNumber = COLUMN_KEY_TO_NUMBER_MAP[tableId][columnKey];
                if (!columnNumber) {
                    console.warn(`Unknown column key in table ${tableId}: ${columnKey}`);
                    return;
                }
                
                const value = rowData[columnKey];
                if (value !== null && value !== undefined) {
                    jsonData[tableId][jsonRowId][columnNumber] = value;
                }
            });
        });
    });
    
    return jsonData;
}
